import { MidiaProdutoVitrine } from "@/components/vitrine/components/MidiaProdutoVitrine"
import { Device } from "@/components/vitrine/data/device"
import type { Produto } from "@/components/vitrine/types/produto.props"
import { isDev } from "@/utils/enviroment-detector"
import { priceFormatter } from "@/utils/formatter"
import { getLinkProduto } from "@/utils/getLinkProduto"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import { BotaoComprarTimer } from "../../../components/BotaoComprarTimer"
import { FavoriteButton } from "@/components/vitrine/components/Favorite-button"

interface ItemOfertaProps {
    hostImagem: string
    produto: Produto
    produtoDestaque: Produto
    precoPrincipal: number
    exibeValoresSomenteLogado: boolean
    blackfriday: boolean
    device: number
    zordHintLoading: string
    validaTempoVitrine: boolean
    vitrineButtonAddToCart: string
    width: number
    height: number
    hoverImagensVitrine: boolean
    hoverImagensVitrineMobile: boolean
    utilizaFavoritosVitrine: boolean
}

export function ItemOferta({
    hostImagem,
    produto,
    produtoDestaque,
    precoPrincipal,
    exibeValoresSomenteLogado,
    blackfriday,
    device,
    zordHintLoading,
    validaTempoVitrine,
    vitrineButtonAddToCart,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine
}: ItemOfertaProps){
    let precoItem = 0
    let percentualDescontoItem = 0
    let iconPagamento = ''

    if (produto.percentual_off && produto.percentual_off > 0) {
        percentualDescontoItem = produto.percentual_off
    } else {
        percentualDescontoItem = 0
    }

    if (precoPrincipal == 1 && produto.valor_boleto && produto.valor_boleto > 0) {
        precoItem = produto.valor_boleto
        iconPagamento = getResourceFromS3('assets/global/vitrines-landing-page', 'icon-boleto.svg')

        if (produto.valor_de && produto.valor_de > 0 && percentualDescontoItem == 0) {
            percentualDescontoItem = (100 - (produto.valor_boleto / produto.valor_de * 100))
        }
    } else if (precoPrincipal == 2 && produto.valor_cartao && produto.valor_cartao[0] > 0) {
        precoItem = produto.valor_cartao[5] ? produto.valor_cartao[5].valor : produto.valor_cartao[1]
        iconPagamento = getResourceFromS3('assets/global/vitrines-landing-page', 'icon-card.svg')

        if (produto.valor_de && produto.valor_de > 0 && percentualDescontoItem == 0) {
            percentualDescontoItem = (100 - (precoItem / produto.valor_de * 100))
        }
    } else if (precoPrincipal == 4 && produto.valor_pix && produto.valor_pix > 0) {
        precoItem = produto.valor_pix
        iconPagamento = getResourceFromS3('assets/global/vitrines-landing-page', 'icon-pix.svg')

        if (produto.valor_de && produto.valor_de > 0 && percentualDescontoItem == 0) {
            percentualDescontoItem = (100 - (produto.valor_pix / produto.valor_de * 100))
        }
    }

    const hasDiscount = Boolean(produto.valor_de && produto.valor_de > precoItem)
    const hasPrice = precoItem > 0

    return (
        exibeValoresSomenteLogado ? (
            <div className={`item-oferta product-card center flex${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' center' : ''}`}>
                <div className="box-info-topo flex space-between">
                    <div className="box-img-item flex justify-center">
                        <a href={getLinkProduto(produto)} className={`${produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                            <figure className={`flex ${utilizaFavoritosVitrine ? 'has-favorite-button' : ''}`}>
                               <MidiaProdutoVitrine
                                    hostImagem={hostImagem}
                                    produto={produto}
                                    width={width}
                                    height={height}
                                    hoverImagensVitrine={hoverImagensVitrine}
                                    hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                />

                                {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                            </figure>
                        </a>
                    </div>
                    <div className="box-info-item">
                        <a href={getLinkProduto(produto)}  className={`${produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                            <h3 className="title-item">{produto.nome}</h3>
                        </a>
                        <div className="valores-logados-vitrine">
                            <span>
                                Faça login para ver os preços
                            </span>

                            <a href={`/login?redir=${encodeURIComponent(globalThis.window.location.href)}`} className="btn-comprar-vitrine flex center justify-center">
                                Fazer login
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <>
                <div className="box-info-topo flex space-between">
                    <div className="tags-vitrine flex">
                        {hasDiscount && (
                            <div className="tag tag-desconto flex">
                                <span className="icon-tag flex">
                                    <img
                                        className="lazyload lazyload-svg"
                                        src={isDev() ? getResourceFromS3('assets/global/blackfriday', 'fire.svg') : zordHintLoading}
                                        data-src={getResourceFromS3('assets/global/blackfriday', 'fire.svg')}
                                        width="16"
                                        height="16"
                                        alt="Oferta Blackfriday"
                                        title="Oferta Blackfriday"
                                    />
                                </span>
                                <span className="tag-off">{Math.round(percentualDescontoItem)}% OFF</span>
                            </div>
                        )}

                        {(blackfriday && ![Device.MOBILE, Device.APP, Device.TABLET].includes(device)) && (
                            <div className="tag tag-black-friday flex">
                                <span className="icon-tag flex">
                                    <img
                                        className="lazyload lazyload-svg"
                                        src={isDev() ? getResourceFromS3('assets/global/blackfriday', 'fire.svg') : zordHintLoading}
                                        data-src={getResourceFromS3('assets/global/blackfriday', 'fire.svg')}
                                        width="16"
                                        height="16"
                                        alt="Oferta Blackfriday"
                                        title="Oferta Blackfriday"
                                    />
                                </span>
                                <span className="text-black">Restam poucas unidades</span>
                            </div>
                        )}
                    </div>
                </div>
                <a href={getLinkProduto(produto)} className={`${produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                    <div className={`item-oferta product-card center flex${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' center' : ''}${hasDiscount ? ' has-discount' : ''}`}>
                        <div className="box-img-item flex justify-center">
                            <figure className={`flex ${utilizaFavoritosVitrine ? 'has-favorite-button' : ''}`}>
                                <MidiaProdutoVitrine
                                    hostImagem={hostImagem}
                                    produto={produto}
                                    width={width}
                                    height={height}
                                    hoverImagensVitrine={hoverImagensVitrine}
                                    hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                />

                                {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                            </figure>
                        </div>
                        <div className="box-info-item">
                            <h3 className="title-item">{produto.nome}</h3>

                            <div className={`box-price flex center${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' justify-center' : ''}`}>
                                <div className={`icon-pagamento flex center${(precoPrincipal == 4 && produtoDestaque.valor_pix && produtoDestaque.valor_pix > 0) ? ' icon-pagamento-pix' : ''}`}>
                                    <img
                                        className="lazyload lazyload-svg"
                                        src={isDev() ? iconPagamento : zordHintLoading}
                                        data-src={iconPagamento}
                                        width="24"
                                        height="24"
                                        alt="Ícone pagamento"
                                        title="Ícone pagamento"
                                    />
                                </div>
                                <div className="flex column">
                                    {hasDiscount && (
                                        <span className="old-price-item">De: {priceFormatter.format(produto.valor_de)}</span>
                                    )}

                                    {hasPrice && (
                                        <span className="price-item">Por: {priceFormatter.format(precoItem)}</span>
                                    )}
                                </div>
                            </div>

                            <BotaoComprarTimer
                                produto={produto}
                                validaTempoVitrine={validaTempoVitrine}
                                zordHintLoading={zordHintLoading}
                                vitrineButtonAddToCart={vitrineButtonAddToCart}
                                device={device}
                            />
                        </div>
                    </div>
                </a>
            </>
        )
    )
}